// Spreadsheet formula-injection guards shared by every CSV the CRM writes or re-reads.

/** Papa's `escapeFormulae` pattern. Papa's default uses `.*$`, which misses cells with a line break. */
export const FORMULA_LEAD = /^[=+\-@\t\r]/;

/** Undoes the `'` that escapeFormulae (or Excel) puts before a formula character, so a corrected file round-trips. */
export const stripFormulaGuard = (cell: string): string =>
  /^'[=+\-@]/.test(cell) ? cell.slice(1) : cell;
